import { getEntity } from 'entman';

import schemas from 'schemas';


export function getTransaction(state, id, raw) {
  return getEntity(state, schemas.Transaction, id, raw);
}
